const CLINIC_START_YEAR = 2006;
const CLINIC_START_MONTH = 0;
const BASELINE_YEARS = 20;
const BASELINE_ATTENDANCES = 24000;
const MONTHLY_ATTENDANCES = BASELINE_ATTENDANCES / (BASELINE_YEARS * 12);

export const getClinicNumbers = () => {
  const today = new Date();
  const monthsSinceStart =
    (today.getFullYear() - CLINIC_START_YEAR) * 12 +
    (today.getMonth() - CLINIC_START_MONTH);
  const years = Math.max(0, Math.floor(monthsSinceStart / 12));
  const attendances = Math.max(0, Math.floor(monthsSinceStart * MONTHLY_ATTENDANCES));

  const attendancesText = attendances.toLocaleString('pt-BR');
  const attendancesCompact =
    attendances >= 1000
      ? `${(attendances / 1000).toLocaleString('pt-BR', {
          maximumFractionDigits: 1,
        })}k`
      : attendancesText;

  return { years, attendancesText, attendancesCompact };
};
